import type { MotionProps, Transition } from "framer-motion"

type Variants = NonNullable<MotionProps["variants"]>

const EASE_OUT_SOFT = [0.22, 1, 0.36, 1] as const

export const TRANSITION = {
	fast: { duration: 0.14, ease: EASE_OUT_SOFT },
	base: { duration: 0.22, ease: EASE_OUT_SOFT },
	slow: { duration: 0.32, ease: EASE_OUT_SOFT },
	spring: { type: "spring", stiffness: 420, damping: 32, mass: 0.7 },
} satisfies Record<string, Transition>

export const fadeUp: Variants = {
	hidden: { opacity: 0, y: 8 },
	visible: { opacity: 1, y: 0, transition: TRANSITION.base },
	exit: { opacity: 0, y: -4, transition: TRANSITION.fast },
}

export const fadeIn: Variants = {
	hidden: { opacity: 0 },
	visible: { opacity: 1, transition: TRANSITION.base },
	exit: { opacity: 0, transition: TRANSITION.fast },
}

export const scalePop: Variants = {
	idle: { scale: 1 },
	pop: { scale: [1, 1.28, 1], transition: { duration: 0.32, times: [0, 0.4, 1] } },
}

export function staggerContainer(stagger = 0.04, delayChildren = 0): Variants {
	return {
		hidden: {},
		visible: { transition: { staggerChildren: stagger, delayChildren } },
		exit: {},
	}
}
